import { render, staticRenderFns } from "./Escola.vue?vue&type=template&id=4a33d3d6&"
import script from "./Escola.vue?vue&type=script&lang=js&"
export * from "./Escola.vue?vue&type=script&lang=js&"
import style0 from "./Escola.vue?vue&type=style&index=0&id=4a33d3d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports